"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityRow = exports.EntityRowDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_follow_controls_1 = require("./entity-follow-controls");
var coalesce_1 = require("../../utils/coalesce");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var entity_value_1 = require("./entity-value");
var entity_link_value_1 = require("./entity-link-value");
var lodash_1 = require("lodash");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var content_1 = require("../elements/content");
var date_calendar_1 = require("../elements/date-calendar");
var entity_followers_badge_1 = require("./entity-followers-badge");
var truncate_words_1 = require("../../utils/truncate-words");
exports.EntityRowDefaultProps = {
  showDescription: false,
  maxDescriptionLength: 1000
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n    align-items: stretch;\n    width: 100%;\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n    align-items: stretch;\n    width: 100%;\n    box-sizing: border-box;\n  "])), theme_1.theme.FONT_SIZE(15)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var ColumnStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var StartStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "], ["\n    ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "])), ColumnStyles, theme_1.theme.UNIT(3))
});
var EndStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), ColumnStyles)
});
var FollowControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-top: ", ";\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.6em;\n  "], ["\n    padding-top: ", ";\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.6em;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('text'))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PublishedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
var CreatedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  "], ["\n    font-size: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2))
});
var CreatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Start: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  End: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), EndStyles),
  FollowControls: (0, styled_components_1.default)(entity_follow_controls_1.EntityFollowControls)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), FollowControlsStyles),
  Followers: (0, styled_components_1.default)(entity_followers_badge_1.EntityFollowers)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), FollowControlsStyles),
  Published: (0, styled_components_1.default)(date_calendar_1.DateCalendar)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PublishedStyles),
  Updated: (0, styled_components_1.default)(date_calendar_1.DateCalendar)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), CreatedStyles),
  Creator: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var EntityRow = function (props) {
  var className = props.className,
    entity = props.entity,
    showDescription = props.showDescription,
    valueComponent = props.valueComponent,
    showFollowControls = props.showFollowControls,
    maxDescriptionWords = props.maxDescriptionWords,
    showPublishDate = props.showPublishDate,
    showCreator = props.showCreator,
    name = props.name,
    showLabel = props.showLabel,
    imageSize = props.imageSize,
    children = props.children,
    variant = props.variant,
    wrap = props.wrap,
    subtitle = props.subtitle,
    label = props.label,
    imageSpacing = props.imageSpacing,
    showMenu = props.showMenu,
    controls = props.controls,
    highlight = props.highlight,
    maxDescriptionLength = props.maxDescriptionLength;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var description = (0, coalesce_1.coalesce)(entity, ['description.text', 'openGraph.description.plain', 'openGraph.description.text']);
  var hasDescription = showDescription && description;
  var showFollowers = defn && !showFollowControls && defn.useFollowers && props.showFollowers === undefined ? showDescription : props.showFollowers;
  var useLinks = props.useLinks === undefined ? defn && (0, lodash_1.includes)(defn.autoRoutes, "details") : props.useLinks;
  var Value = valueComponent || defn.components.value || (useLinks ? My.LinkValue : My.Value);
  var published = (0, lodash_1.get)(entity, 'published');
  var updated = (0, lodash_1.get)(entity, 'updated');
  var updatedBy = (0, lodash_1.get)(entity, 'updatedBy');
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Start, null, react_1.default.createElement(Value, {
    wrap: wrap,
    highlight: highlight,
    label: label,
    imageSize: imageSize,
    subtitle: subtitle,
    showMenu: showMenu,
    variant: variant,
    imageSpacing: imageSpacing,
    showLabel: showLabel,
    name: name,
    entity: entity
  })), react_1.default.createElement(My.End, null, showFollowers && !controls && react_1.default.createElement(My.Followers, {
    entity: entity
  }), showFollowControls && !controls && react_1.default.createElement(My.FollowControls, {
    entity: entity
  }), controls, showPublishDate && published && react_1.default.createElement(My.Published, {
    date: published
  }), showCreator && updatedBy && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.Creator, {
    label: "Updated By:",
    entity: updatedBy
  }), react_1.default.createElement(My.Updated, {
    date: updated
  })))), hasDescription && react_1.default.createElement(My.Description, {
    className: "shp-entity-row__description"
  }, react_1.default.createElement(markdown_to_jsx_1.default, null, maxDescriptionWords ? (0, truncate_words_1.truncateWords)(description, {
    max: maxDescriptionWords
  }) : maxDescriptionLength ? (0, lodash_1.truncate)(description, {
    length: maxDescriptionLength
  }) : description)), children);
};
exports.EntityRow = EntityRow;
exports.EntityRow.defaultProps = exports.EntityRowDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;